import { render, staticRenderFns } from "./ProjCheckEdit.vue?vue&type=template&id=9a96876e"
import script from "./ProjCheckEdit.vue?vue&type=script&lang=js"
export * from "./ProjCheckEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports